import React, {useEffect} from 'react'
import './main.css'

import Aos from 'aos'
import 'aos/dist/aos.css'

import {HiOutlineLocationMarker} from 'react-icons/hi'
import {BsClipboardCheck} from 'react-icons/bs'
import img from '../../Assets/img/img (1).jpg'
import img2 from '../../Assets/img/img(2).jpg'
import img3 from '../../Assets/img/img(3).jpg'
import img4 from '../../Assets/img/img(4).jpg'
import img5 from '../../Assets/img/img(5).jpg'
import img6 from '../../Assets/img/img(6).jpg'

const Data = [
  {
    id:1,
    imgSrc:img,
    desTitle: 'Gunung Bromo',
    location: ' Jawa Timur',
    grade: 'CULTURAL RELAX',
    fees: 'Rp29.000',
    description: 'Gunung Bromo terkenal sebagai objek wisata utama di Jawa Timur. Sebagai sebuah objek wisata, Bromo menjadi menarik karena statusnya sebagai gunung berapi yang masih aktif. Gunung Bromo termasuk dalam kawasan Taman Nasional Bromo Tengger Semeru.'
  },
  {
    id:2,
    imgSrc: img2,
    desTitle: 'Taman Nasional Wakatobi',
    location: 'Sulawesi Tenggara',
    grade: 'CULTURAL RELAX',
    fees: 'Rp160.000',
    description: 'Taman Nasional Wakatobi di Sulawesi Tenggara merupakan salah satu surga wisata Indonesia yang wajib kamu kunjungi sekali seumur hidup. Kawasan terumbu karang terluas di dunia setelah Great Barrier Reef (Australia) ini memiliki luas 1,4 juta hektare, dengan ribuan spesies flora dan fauna hidup di dalamnya.'
  },
  {
    id:3,
    imgSrc: img3,
    desTitle: 'Pulau Komodo',
    location: 'Kepulauan Nusa Tenggara',
    grade: 'CULTURAL RELAX',
    fees: 'Rp3.750.000',
    description: 'Pulau Komodo masuk dalam kawasan Taman Nasional Komodo bersama pulau-pulau lain di sekitar Kepulauan Nusa Tenggara. Pada tahun 1986, UNESCO menetapkan tempat wisata di Indonesia ini sebagai salah satu situs warisan dunia. Pulau ini dianggap sebagai habitat binatang komodo yang wajib dilindungi. Salah satu penghargaan tertinggi yang berhasil diraih adalah berhasil masuk dalam jajaran tujuh kejaiban alam di dunia atau yang lebih dikenal dengan New Seven Wonders of Nature pada tahun 2011.'
  },
  {
    id:4,
    imgSrc: img4,
    desTitle: 'Trio Gili',
    location: 'Lombok',
    grade: 'CULTURAL RELAX',
    fees: 'Rp5.000',
    description: 'Trio Gili merupakan tiga pulau cantik yang ada di Lombok. Ketiga pulau tersebut antara lain Gili Trawangan, Gili Meno dan Gili Air. Ketiganya tak hanya dikenal oleh wisatawan domestik, tapi juga telah berhasil mengundang banyak wisatawan mancanegara untuk datang.'
  },
  {
    id:5,
    imgSrc: img5,
    desTitle: 'Raja Ampat',
    location: 'Papua',
    grade: 'CULTURAL RELAX',
    fees: 'Rp1.700.000',
    description: 'Raja Ampat menjadi primadona baru di dunia pariwisata Indonesia. Pesona tempat wisata terindah di Indonesia. ini mulai banyak dikenal baik oleh wisatawan domestik maupun mancanegara. Raja Ampat sendiri merupakan kumpulan dari pulau-pulau di ujung Papua. Ada empat pulau utama di sini, yaitu Waigeo, Misool, Salawati dan Batanta.'
  },
  {
    id:6,
    imgSrc: img6,
    desTitle: 'Taman Laut Bunaken',
    location: 'Sulawesi Utara',
    grade: 'CULTURAL RELAX',
    fees: 'Rp5.000',
    description: 'Taman Laut Bunaken menjadi salah satu tempat wisata terindah di Indonesia yang lagi-lagi ditetapkan UNESCO sebagai situs warisan dunia, tepatnya pada tahun 2005. Hal ini dikarenakan kekayaan dan keragaman biota lautnya yang luar biasa mulai dari terumbu karang, rumput laut sampai spesies ikan yang ada.'
  },
]

const Main = () => {

  useEffect(()=>{
    Aos.init({duration: 2000})
  },[])

  return (
    <section className="main container section">
      <div className="secTitle">
        <h3 data-aos="fade-right" className='title'>
          Most visited destination
        </h3>
      </div>

      <div className="secContent grid">
        {
          Data.map(({id, imgSrc, desTitle, location, grade, fees, description})=>{
            return (
              <div key={id} className="singleDestination" data-aos="fade-up" >
                <div className="imageDiv">
                  <img src={imgSrc} alt={desTitle} />
                </div>

                <div className="cardInfo">
                  <h4 className="destTitle">{desTitle}</h4>
                  <span className="continent flex">
                    <HiOutlineLocationMarker className='icon'/>
                    <span className="name">{location}</span>
                  </span>

                  <div className="fees flex">
                    <div className="grade">
                      <span>{grade}</span>
                    </div>
                    <div className="price">
                      <h5>{fees}</h5>
                    </div>
                  </div>

                  <div className="desc">
                    <p>{description}</p>
                  </div>

                  <div className="btn flex">
                    Details <BsClipboardCheck className='icon'/>
                  </div>
                </div>

              </div>
            )
          })
        }
      </div>
    </section>
  )
}

export default Main